/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressAutoCompleteResult } from "../models/AddressAutoCompleteResult"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class AddressService {
  /**
   * AutoComplete the Address by ZipCode
   * AutoComplete the Address by ZipCode
   * @param zipCode ZipCode (Japanese)
   * @param xAccessToken
   * @returns AddressAutoCompleteResult successful operation
   * @throws ApiError
   */
  public static autoCompleteAddressByZipCode(
    zipCode: string,
    xAccessToken?: string
  ): CancelablePromise<AddressAutoCompleteResult> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/address/zipcode/{zipCode}",
      path: {
        zipCode: zipCode,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      errors: {
        400: `Bad Request (zipCode 0000000)`,
        500: `Internal Server`,
      },
    })
  }
}
